import React, { useEffect } from "react";
import NavigationHeader from "./components/NavigationHeader";
import HeroSection from "./components/HeroSection";
import AnnouncementsSection from "./components/AnnouncementsSection";
import AboutPPSRNP from "./components/AboutPPSRNP";
import TouristSpots from "./components/TouristSpots";
import WildlifeInfo from "./components/WildlifeInfo";
import CommunityInfo from "./components/CommunityInfo";
import FestivalsEvents from "./components/FestivalsEvents";
import LivePulseDashboard from "./components/LivePulseDashboard";
import ConservationStories from "./components/ConservationStories";
import InteractiveSpeciesCounter from "./components/InteractiveSpeciesCounter";
import CredibilityNetwork from "./components/CredibilityNetwork";
import FooterSection from "./components/FooterSection";

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[var(--color-background)]">
      <NavigationHeader />
      <HeroSection />
      <AnnouncementsSection />
      <AboutPPSRNP />
      <TouristSpots />
      <WildlifeInfo />
      <CommunityInfo />
      <FestivalsEvents />
      <LivePulseDashboard />
      <ConservationStories />
      <InteractiveSpeciesCounter />
      <CredibilityNetwork />
      <FooterSection />
    </div>
  );
};

export default Homepage;